import FEATURES from '@components/Sandbox/features';
import { Select, SelectItem } from '@atoms/new/select';
import DoneIcon from '@mui/icons-material/Done';

export const FeaturesDropdown = ({ feature, setFeature, featureDetails }: any) => {
  return (
    <Select
      className="w-60"
      selectedKeys={feature}
      onSelectionChange={(key: any) => setFeature(key)}
      startContent={FEATURES.find((f) => f.slug === featureDetails?.slug)?.icon || null}
    >
      {FEATURES.map((feature) => (
        <SelectItem
          selectedIcon={({ isSelected }) => (
            <div
              className={`w-6 h-6 absolute top-1 right-2 ${
                isSelected ? '' : 'hidden'
              }`}
            >
              <DoneIcon fontSize="small" />
            </div>
          )}
          startContent={feature?.icon || null}
          key={feature.slug}
        >
          {feature.name}
        </SelectItem>
      ))}
    </Select>
  );
};
